import cn from 'classnames';
import { useIntl } from 'react-intl';
import { Element } from 'react-scroll';
import LavoraConNoiCardShared from '@components/lavora-con-noi/rework/cardshared/cardshared';
import { useCallback, useState } from 'react';
import HeaderVideo from '@components/lavora-con-noi/rework/header/video';

const CybersecurityPartners = () => {
  const intl = useIntl();

  // Stato UNICO per la modale + src selezionata
  const [videoState, setVideoState] = useState({ open: false, src: '' });

  const openVideo = useCallback((src) => {
    setVideoState({ open: true, src });
  }, []);

  const closeVideo = useCallback(() => {
    setVideoState((v) => ({ ...v, open: false }));
  }, []);

  return (
    <div className="snf-lx-components-azienda-partners" style={{ display: 'contents' }}>
      <Element name="partners">
        <div className={cn('div-image', `snf-bg-repeat-no-repeat`)}>
          <div className="container-fluid padding px-5 py-5">
            <div className="row ml-2 mb-5">
              <div className="col-auto snf-font-32 mb-4">
                {intl.formatMessage(
                  { defaultMessage: '<strong>Le nostre partnership</strong>' },
                  { strong: (chunks) => <strong>{chunks}</strong> }
                )}
              </div>
            </div>

            {/* Cards */}
            <div className="row w-100 mb-5 justify-content-center m-0">
              <div className="col-12 mb-3 col-md-4 mb-md-0 pl-0 pr-0 pr-md-3">
                <LavoraConNoiCardShared
                  icon={
                    <div
                      style={{
                        width: 260, // size massima “di base”
                        maxWidth: '100%', // si riduce se il contenitore è più stretto
                        height: 100, // altezza uniforme per tutte le card (sezione 1)
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        overflow: 'hidden' // evita sbordi
                      }}
                    >
                      <img
                        src="/images/Microsoft-logo_rgb_c-gray.png"
                        alt="Logo Microsoft"
                        style={{
                          maxWidth: '100%',
                          maxHeight: '100%',
                          width: 'auto',
                          height: 'auto',
                          objectFit: 'contain',
                          display: 'block'
                        }}
                      />
                    </div>
                  }
                  // title={intl.formatMessage({ defaultMessage: 'Microsoft' })}
                  text={intl.formatMessage({
                    defaultMessage:
                      'Quando esperienza e tecnologia si incontrano, nascono nuove opportunità, e la collaborazione con IBM e Microsoft nasce proprio per questo: offrire soluzioni innovative di Cyber Security e Data Protection. L’obiettivo? Aiutare le aziende a trasformare i propri modelli di sicurezza grazie a tecnologie e best practice combinate.'
                  })}
                  showButton
                  buttonLabel={intl.formatMessage({ defaultMessage: 'Guarda il video' })}
                  onOpenVideo={openVideo} // <— passa la funzione che accetta una src
                  videoSrc="/assets/VideoIBMMicrosoft.mp4"
                  /* Secondo "bottone" come link */
                  // secondaryButtonLabel={intl.formatMessage({ defaultMessage: 'Vai al blog IBM' })}
                  // secondaryHref="https://www.sistinf.it/azienda"
                  // secondaryTarget="_blank"
                  // secondaryRel="noopener noreferrer"
                />
              </div>

              <div className="col-12 col-md-4 pl-0 pl-md-3 pr-0">
                <LavoraConNoiCardShared
                  icon={
                    <div
                      style={{
                        width: 240,
                        maxWidth: '100%',
                        height: 100,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        overflow: 'hidden'
                      }}
                    >
                      <img
                        src="/images/PANW_Parent_Brand_Primary_Logo_RGB (15).png"
                        alt="Logo Palo Alto Networks"
                        style={{
                          maxWidth: '100%',
                          maxHeight: '100%',
                          width: 'auto',
                          height: 'auto',
                          objectFit: 'contain',
                          display: 'block'
                        }}
                      />
                    </div>
                  }
                  // title={intl.formatMessage({ defaultMessage: 'Palo Alto Networks' })}
                  text={intl.formatMessage({
                    defaultMessage:
                      'Non basta proteggere il presente: serve costruire il futuro. La nostra partnership con IBM e Palo Alto Networks nasce da una missione condivisa: aiutare le aziende a crescere in sicurezza, trasformando la complessità in valore e aprendo la strada a un futuro digitale più sicuro.'
                  })}
                  showButton
                  buttonLabel={intl.formatMessage({ defaultMessage: 'Guarda il video' })}
                  onOpenVideo={openVideo}
                  videoSrc="/assets/PANW_IBM_Long_Video_Subtitled.mp4"
                  /* Secondo "bottone" come link */
                  // secondaryButtonLabel={intl.formatMessage({ defaultMessage: 'Vai al blog IBM' })}
                  // secondaryHref="https://www.sistinf.it/azienda"
                  // secondaryTarget="_blank"
                  // secondaryRel="noopener noreferrer"
                />
              </div>
              <div className="col-12 mb-3 col-md-4 mb-md-0 px-0 px-md-3">
                <LavoraConNoiCardShared
                  icon={
                    <div
                      style={{
                        width: 240,
                        maxWidth: '100%',
                        height: 100,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        overflow: 'hidden'
                      }}
                    >
                      <img
                        src="/images/Tenable_Logo_fullcolor_180w.png"
                        alt="Logo Tenable"
                        style={{
                          maxWidth: '100%',
                          maxHeight: '100%',
                          width: 'auto',
                          height: 'auto',
                          objectFit: 'contain',
                          display: 'block'
                        }}
                      />
                    </div>
                  }
                  // title={intl.formatMessage({ defaultMessage: 'Tenable' })}
                  text={intl.formatMessage({
                    defaultMessage:
                      'Una sicurezza davvero efficace si misura sui risultati. La partnership con IBM e Tenable rappresenta un pilastro della nostra offerta di Cyber Security Services in Italia, aiutando i clienti a identificare, ridurre e monitorare il rischio in modo continuo.'
                  })}
                  showButton
                  // Primo bottone (primario)
                  buttonLabel={intl.formatMessage({ defaultMessage: 'Guarda il video' })}
                  onOpenVideo={openVideo}
                  videoSrc="/assets/VideoTenable.mp4"
                  /* Secondo "bottone" come link */
                  // secondaryButtonLabel={intl.formatMessage({ defaultMessage: 'Vai al blog IBM' })}
                  // secondaryHref="https://www.sistinf.it/azienda"
                  // secondaryTarget="_blank"
                  // secondaryRel="noopener noreferrer"
                />
              </div>
            </div>

            {/* UNICA modale/overlay per il video */}
            <HeaderVideo
              fallbackSrc={videoState.src}
              open={videoState.open}
              onClose={closeVideo}
            />
          </div>
        </div>
      </Element>
    </div>
  );
};

CybersecurityPartners.displayName = 'Partners';
export { CybersecurityPartners };
